import React from 'react'
import classnames from 'classnames'
import { PropTypes } from 'prop-types'
import styles from './styles.module.scss'

/**
 * color one of green|amber|grey|red
 * onClick: null for no-clickable|function for clickable
 */
export const TextPill = ({ className, color, onClick = null, testid, value = '' }) =>
    value ? (
        <span className={classnames(styles.TextPill, styles[color], onClick && styles.clickable, className)} {...{ onClick, testid }}>
            {value}
        </span>
    ) : null

TextPill.propTypes = {
    className: PropTypes.string,
    color: PropTypes.oneOf(['green', 'amber', 'grey', 'red']),
    onClick: PropTypes.oneOf([null, PropTypes.func]),
    testid: PropTypes.string,
    value: PropTypes.string.isRequired,
}
